export default class settingsCustomFields {
    constructor() {
        return {
            restrict: 'E',
            template: require('../../../../views/setting/partials/custom-fields.html'),
            replace: true,
            scope: {
                show: '=',
                account: '='
            },
            controller: CustomFieldCtrl,
            controllerAs: 'cf'
        }
    }
};

class CustomFieldCtrl {
    constructor($scope, $filter, Customization, SweetAlert) {
        this._translator = $filter('translate');
        this._scope = $scope;

        this.customRepo = Customization;
        this.alerter = SweetAlert;

        this.customFields = [];
        this.formattedFields = [];

        this._scope.$on('sender:hasCustomFields', (event, customFields) => {
            this.customFields = customFields;
        });

        this.getCustomizations();
    }

    setDefaultFields() {
        this.formatAndAddField(this._translator('GLOBAL:PHONE_NUMBER'), null, null, null, 'phone_number');
        this.formatAndAddField('Email', null, null, null, 'email');
    };

    formatAndAddField(name, groupName, groupID, type, id) {
        this.formattedFields.push({
            name: name,
            groupName: groupName,
            groupID: groupID,
            type: type,
            id: id,
            chosen: false
        });
    };

    addCustomField() {
        this.customFields.push({ key: '', value: '' });
    };

    deleteCustomField(index) {
        this.customFields.splice(index, 1);
        this.updateCustomFields();
    };

    getCustomizations() {
        this.customRepo.allGroups().then((groups) => {
            this.formattedFields = [];
            this.setDefaultFields();

            angular.forEach(groups.data, (group) => {
                angular.forEach(group.fields, (field) => {
                    this.formatAndAddField(
                        field.name,
                        group.name,
                        group.id,
                        field.type,
                        group.name + "." + field.name
                    );
                });
            });
        });
    };

    validateCustomFields() {
        let success = true;

        angular.forEach(this.customFields, (field) => {
            if (! field.key || ! field.value) {
                success = false;

                this.alerter.swal({
                    title: this._translator('GLOBAL:FLASH:OOPS'),
                    text: this._translator('SUBSCRIBER:IMPORT:INVALID_AUTO_MAPPING'),
                    type: 'error'
                });
            }
        });

        return success;
    };

    updateCustomFields() {
        if (this.validateCustomFields()) {
            this._scope.$emit('sender:customFields:update', this.customFields);
        }
    };
}
